module.exports = __webpack_public_path__ + "img/House Sale.79054675.svg";